import store from 'store'
import axios from 'axios'

const state = {
  userInfo: null,
  hasLogin: false,
  terminals: [],
  groups: [],
};

const getters = {
  tel: state => state.userInfo.tel,
  isSchool: state => state.userInfo.isSchool,
  user: state => state.userInfo,
  terminals: state => state.terminals,
  groups: state => state.groups,
};

const actions = {

};

const mutations = {
  // 记录用户信息
  recordUser(state, info) {
    if(!store.get("storeUser")){
      store.set('storeUser', info)
    }
    axios.defaults.headers.common['authorization'] = 'Bearer ' + info.token;
    state.userInfo = info.user;
    state.hasLogin = true;
  },
  clearUser(state) {
    state.userInfo = null;
    state.hasLogin = false;
    store.remove('storeUser');
  },
  recordGroups(state, groups) {
    state.groups = groups.map(g => {
      g.tags.forEach(t => {
        if (t !== "4180" && t !== "552" && t !== "5590") {
          delete g.tags[t]
        }
      });
      return g
    });
  },
  recordTerminals(state, terminals) {
    state.terminals = terminals;
  }
};


export default {
  namespaced: true, //  module 命名空间，以后在引用的时候都需要用到文件名/action 或者 mutations 或者 state
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js